import { Stack, HStack, useColorModeValue } from '@ecoinvent/ui';

import { supportedFilters, supportedV4Filters } from 'hooks/data/search/constants';
import { ElasticBucket, FilterMap, ElasticAggregation, GeographyHierarchy } from 'hooks/data/search/types';
import { useIsShowingV4 } from 'hooks/useV4';

import FilterComboBox from '../FilterComboBox';
import GeographiesSelect from '../V4GeographiesFilter';

import { LabeledFilterBucket } from './types';

type Props = {
  onFilterChange: (field: keyof FilterMap, data: ElasticBucket[]) => void;
  selectedItems: Record<keyof FilterMap, LabeledFilterBucket>;
  aggregations: Record<keyof FilterMap, ElasticAggregation> | undefined;
  geographyHierarchy?: GeographyHierarchy;
  isLoading?: boolean;
};

const ActivitySearchFilters = ({ onFilterChange, selectedItems, aggregations, geographyHierarchy, isLoading }: Props) => {
  const comboBoxBg = useColorModeValue('white', 'gray.700');

  const isShowingV4 = useIsShowingV4();

  return (
    <Stack spacing={5} w="100%" data-tour-target="search-filters">
      <HStack w="100%">
        <Stack spacing={2} w="100%" direction={{ base: 'column', lg: 'row' }} alignItems={{ base: 'stretch', lg: 'center' }}>
          {!isShowingV4 ? (
            supportedFilters.map((f) => (
              <Stack width={'100%'} key={f.label}>
                <FilterComboBox
                  displayName={f.label}
                  placeholder={f.label}
                  onChange={(v) => {
                    onFilterChange(f.field, v ?? []);
                  }}
                  isDisabled={isLoading || !aggregations?.[f.field]?.buckets?.length}
                  selectedItems={selectedItems[f.field]?.values}
                  options={aggregations?.[f.field].buckets ?? []}
                  showSelectedItems={false}
                  bg={comboBoxBg}
                  w="100%"
                  flex={1}
                />
              </Stack>
            ))
          ) : (
            <>
              <GeographiesSelect onFilterChange={onFilterChange} geographyHierarchy={geographyHierarchy} />
              {supportedV4Filters.map((f) => (
                <Stack width={'100%'} key={f.label}>
                  <FilterComboBox
                    displayName={f.label}
                    placeholder={f.label}
                    onChange={(v) => {
                      onFilterChange(f.field, v ?? []);
                    }}
                    isDisabled={isLoading || !aggregations?.[f.field]?.buckets?.length}
                    selectedItems={selectedItems[f.field]?.values}
                    options={aggregations?.[f.field].buckets ?? []}
                    showSelectedItems={false}
                    bg={comboBoxBg}
                    w="100%"
                    flex={1}
                  />
                </Stack>
              ))}
            </>
          )}
        </Stack>
      </HStack>
    </Stack>
  );
};
export default ActivitySearchFilters;
